import React, { useState } from 'react';
import { Text, Button, Input, DateInput, MultiSelect } from 'ui';
import { useAuth, updateCampaign } from 'api';
import countries from 'config/countries';

export default function(props) {
  const auth = useAuth();
  const [state, _setState] = useState({...props.campaign});
  const setState = update => _setState({...state, ...update});
  
  let states = [];
  let regions = [];
  if(state.country) {
    state.country.split(',').map(c => c.trim()).forEach(country => {
      const val = countries.find(c => c.value === country);
      if(val) {
        states = [...states, ...(val.states || [])];
        regions = [...regions, ...(val.regions || [])];
      }
    });
  }
  
  function save() {
    updateCampaign(auth.user.companyId, props.campaign.id, state);
    props.onDone();
  }
  
  return (
    <div style={{display:'flex', flexDirection:'row', alignItems:'flex-start', paddingBottom:24}}>
      <Text block style={{flex:1}}>
        <Input label="Name" value={state.name} onChange={name => setState({name})} style={{marginBottom:16}}/>
        
        <Input label="URL" value={state.slug} onChange={slug => setState({slug})} style={{marginBottom:16}}/>
        
        <div style={{display:'flex', flexDirection:'row', marginBottom:16}}>
          <DateInput
            label="Start Date"
            value={state.start}
            onChange={start => setState({start})}
            style={{marginRight:16}}
          />
          <DateInput
            label="End Date"
            value={state.end}
            onChange={end => setState({end})}
          />
        </div>
        
        <div>
          <Text small bold block style={{marginBottom:4}}>Country</Text>
          <MultiSelect
            placeholder="Select Countries"
            label="Country"
            large
            options={countries}
            value={state.country || ""}
            onChange={country => setState({country})}
            style={{flex:1, margin:'0 0 8px 0'}}
            selectedColor="#00b2a8"
          />
          {regions && regions.length > 0 &&
            <MultiSelect
              label="Region"
              placeholder="Select Regions"
              large
              options={regions}
              value={state.region || ""}
              onChange={region => setState({region})}
              style={{flex:1, margin:'0 0 8px 0'}}
              selectedColor="#00b2a8"
            />
          }
          {states && states.length > 0 &&
            <MultiSelect
              label="State"
              placeholder="Select States"
              large
              options={states}
              value={state.state || ""}
              onChange={state => setState({state})}
              style={{flex:1, margin:'0 0 8px 0'}}
              selectedColor="#00b2a8"
            />
          }
        </div>
        
        
      </Text>
      <div style={{marginLeft:80}}>
        <Button 
          label="Save" 
          style={{backgroundColor:'#e3e5e4', marginBottom:24}}
          onClick={save}/>
      </div>
    </div>
  );
}